import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Tabs from "@mui/material/Tabs";
import { ThemeProvider } from "@mui/material/styles";
//Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import { useExpertProfileContext } from "../../../../expert";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
import ConversationTab from "../../conversation-tab/ConversationTab";
const useStyles = makeStyles(() => ({
  root: {
    flexShrink: 0,
    marginRight: 16
  },
  tabsRoot: {
    minWidth: 100
  }
}));
const ConversationTabs = ({
  children,
  activeTab,
  onTabChange,
  message,
  showKnowledge = true,
  showExtraInfo = true,
  suffixTabs,
  secureData = []
}) => {
  const {
    conversationState
  } = message;
  const classes = useStyles();
  const {
    isDarkMode
  } = useExpertProfileContext();
  const theme = React.useMemo(() => modernTheme(isDarkMode ? "dark" : "light"), [isDarkMode]);
  const showSecureTab = React.useMemo(() => {
    var _message$customerSecD;
    return !((message === null || message === void 0 ? void 0 : (_message$customerSecD = message.customerSecData) === null || _message$customerSecD === void 0 ? void 0 : _message$customerSecD.length) > 0);
  }, [message]);
  const isSecureDataView = React.useMemo(() => {
    return !(conversationState.allowSecureDataView && secureData.length > 0);
  }, [conversationState.allowSecureDataView, secureData]);
  const secureDataTabVisibility = React.useMemo(() => {
    if (process.env.REACT_APP_NAME === "CrowdManager") {
      return showSecureTab;
    } else {
      return isSecureDataView;
    }
  }, [isSecureDataView, showSecureTab]);
  const tabCount = React.useMemo(() => {
    let count = 0;
    if (showKnowledge) {
      count++;
    }
    if (conversationState.showClassification) {
      count++;
    }
    if (conversationState.showExtraInfo && showExtraInfo) {
      count++;
    }
    if (conversationState.allowSecureDataView) {
      count++;
    }
    if (Array.isArray(children)) {
      count += children.length;
    } else {
      count++;
    }
    if (Array.isArray(suffixTabs)) {
      count = +children.length;
    } else {
      count++;
    }
    return count;
  }, [message, children, suffixTabs]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: activeTab,
    onChange: (event, value) => {
      if (tabCount > 1) {
        onTabChange(value);
      }
    },
    classes: {
      root: classes.tabsRoot
    },
    variant: tabCount >= 5 ? "scrollable" : tabCount > 1 && tabCount <= 3 ? "fullWidth" : "standard",
    TabIndicatorProps: {
      sx: {
        backgroundColor: theme => theme.palette.primary.light,
        height: "4px"
      }
    }
  }, children, /*#__PURE__*/React.createElement(ConversationTab, {
    id: "classificationTab",
    label: "Classification",
    hide: !conversationState.showClassification,
    mandatory: conversationState.isClassificationMandatory,
    largeMandatory: conversationState.isManagerClassification
  }), /*#__PURE__*/React.createElement(ConversationTab, {
    id: "extraInfoTab",
    label: "Extra Info",
    hide: !conversationState.showExtraInfo || !showExtraInfo
  }), /*#__PURE__*/React.createElement(ConversationTab, {
    id: "secureDataTab",
    label: "Secured Info",
    hide: secureDataTabVisibility
  }), suffixTabs, /*#__PURE__*/React.createElement(ConversationTab, {
    id: "knowledgeTab",
    label: "Knowledge",
    hide: !showKnowledge || !(message !== null && message !== void 0 && message.knowledgeBaseIsActive)
  }))));
};
export default ConversationTabs;
ConversationTabs.propTypes = {
  onTabChange: PropTypes.func.isRequired,
  activeTab: PropTypes.number.isRequired,
  message: PropTypes.object.isRequired,
  children: PropTypes.node,
  showKnowledge: PropTypes.bool,
  showSecureData: PropTypes.bool,
  showExtraInfo: PropTypes.bool,
  suffixTabs: PropTypes.node,
  secureData: PropTypes.array
};